// apps/web/src/lib/utils.ts
//
// shadcn/ui canonical `cn()` utility — Tailwind class merger that resolves
// conflicting utilities (e.g., `cn('p-2', cond && 'p-4')` -> 'p-4').
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
